// extracted by mini-css-extract-plugin
export default {"theme_modal":"WebProfileModal_theme_modal__5z-t0","profile_img":"WebProfileModal_profile_img__kmTb5","member_designation":"WebProfileModal_member_designation__a4jhR"};